export default __webpack_public_path__ + "static/media/bookClubMain.1cce6172.png";